module.exports = "<div class=c-checkout__steps> <div ng-repeat=\"(index, step) in $ctrl.checkout.validSteps\" ng-if=\"step !== 'confirmation'\" class=\"c-step{{ $ctrl.checkout.validSteps.indexOf($ctrl.checkout.step) > index ? ' is-active' : '' }}{{ $ctrl.checkout.validSteps.indexOf($ctrl.checkout.step) === index ? ' is-current' : '' }}\" ng-click=\"$ctrl.travel(index, step)\"> <div class=c-step__indicator></div> <div class=c-step__text> <span>{{$ctrl.checkout.displayName(step)}}</span> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./frontend/storefront/app/modules/checkout/views/steps.html
// module id = 831
// module chunks = 0